var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.4443V5.09139C3 4.63845 3.15447 4.25085 3.46342 3.92857C3.77289 3.60575 4.14474 3.44434 4.57895 3.44434H14.0526C14.4868 3.44434 14.8587 3.60575 15.1682 3.92857C15.4771 4.25085 15.6316 4.63845 15.6316 5.09139V9.27081C15.5 9.24336 15.3718 9.22606 15.2471 9.21892C15.1218 9.21234 14.9868 9.20904 14.8421 9.20904C14.6974 9.20904 14.5626 9.21234 14.4379 9.21892C14.3126 9.22606 14.1842 9.24336 14.0526 9.27081V5.09139H4.57895V13.4708L4.71711 13.3267H10.1645C10.1382 13.4639 10.1216 13.5979 10.1147 13.7286C10.1084 13.8587 10.1053 13.9992 10.1053 14.1502C10.1053 14.3012 10.1084 14.4417 10.1147 14.5719C10.1216 14.7025 10.1382 14.8365 10.1645 14.9737H5.36842L3 17.4443ZM6.15789 8.38551V6.73845H12.4737V8.38551H6.15789ZM6.15789 11.6796V10.0326H10.1053V11.6796H6.15789ZM14.0526 17.4443V14.9737H11.6842V13.3267H14.0526V10.8561H15.6316V13.3267H18V14.9737H15.6316V17.4443H14.0526Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.88dac1464ca38f6c1d67f0ef88d29aad.svg";
export { ForwardRef as ReactComponent };